import { showShortcuts } from "./redux/actions/index";

/* Public Methods Available For LRoot */
function Root(Base, store) {
  class NewRoot extends Base {

    open_shortcuts() {
      store.dispatch(showShortcuts(true));
    }

  }
  return NewRoot;
}

export default Root;
